let mainNavWrapper = document.getElementById('main-nav');
let mainNavMenu = document.getElementById('main-nav-menu');
let mainNavDropdown = document.getElementById('main-nav-dropdown');
let mainNavDropdownMenu = document.getElementById('main-nav-dropdown-menu');
let mainNavDropdownButton = document.getElementById('main-nav-dropdown-button');
let mainNavMenuUtility = document.getElementById('main-nav-menu-utility');
let menuPadding = 0;
if (mainNavWrapper) {
    menuPadding = parseInt(getComputedStyle(mainNavWrapper.querySelector('#main-nav-wrapper')).paddingLeft) * 2;
}
var mainNavItems;
var mainNavItemsArray = [];

export function mainNav() {

    navItemsPlacement();
}

const placeInDropdown = function () {
    var itemsForPlacement = '';
    var counter = 0;

    for (var i = 0; i < mainNavItemsArray.length; i++) {
        if (mainNavItemsArray[i].linkDisplay == 0) {
            itemsForPlacement += '<li>';
            itemsForPlacement += '<a href="' + mainNavItemsArray[i].linkHref + '">';
            itemsForPlacement += mainNavItemsArray[i].linkText;
            itemsForPlacement += '</a>';
            itemsForPlacement += '</li>';
            counter++;
        }
    }

    if (counter > 0) {
        mainNavDropdownMenu.innerHTML = itemsForPlacement;
        mainNavDropdown.classList.remove('hide');
    } else {
        mainNavDropdownMenu.innerHTML = '';
        mainNavDropdown.classList.add('hide');
    }

}

const navItemsPlacement = () => {
    if (mainNavWrapper != null && mainNavMenu != null && mainNavDropdown != null) {
        mainNavItems = mainNavMenu.getElementsByTagName('li');
        for (var i = 0; i < mainNavItems.length; i++) {
            if (mainNavItems.item(i).classList.contains('main-nav-menu-item-mobile-only')
                || mainNavItems.item(i).classList.contains('mobile-nav-context-link')) {
                continue;
            }
             
            let linkItem = mainNavItems.item(i).getElementsByTagName('a')[0];
            const linkMargin = parseInt(getComputedStyle(mainNavItems[i]).marginLeft); //add the 1 rem left margin to the offset width of visible nav items
            let linkOffsetWidth = mainNavItems[i].offsetWidth;
            let navItem = {
                linkTotalWidth: linkOffsetWidth + linkMargin,
                linkText: linkItem.innerText,
                linkHref: linkItem.href,
                linkTarget: linkItem.target,
                linkClass: mainNavItems[i].className,
                linkDisplay: 0 // 0 is deafault to not display and 1 is to display
            }
            mainNavItemsArray.push(navItem);
        }
        navItemsRelocator();

        window.addEventListener("resize", navItemsRelocator);
        mainNavDropdownButton.addEventListener("click", function () {
            mainNavDropdown.classList.toggle('active');
        });
    }
}


const navItemsRelocator = () => {
    const maxWidth = mainNavWrapper.offsetWidth - mainNavMenuUtility.offsetWidth - menuPadding;
    let totalWidth = 0;
    var notFit = false;

    for (var i = 0; i < mainNavItemsArray.length; i++) {
        totalWidth += mainNavItemsArray[i].linkTotalWidth;
        if (maxWidth > totalWidth && notFit == false) {
            mainNavItemsArray[i].linkDisplay = 1;
            mainNavMenu.getElementsByClassName(mainNavItemsArray[i].linkClass)[0].classList.remove('hide');
            notFit = false;
        } else if (maxWidth < totalWidth) {
            mainNavMenu.getElementsByClassName(mainNavItemsArray[i].linkClass)[0].classList.add('hide');
            mainNavItemsArray[i].linkDisplay = 0;
            notFit = true;
        }
    }

    placeInDropdown();
}